import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export const ChangePassword = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const minLen = user?.role === "admin" ? 12 : 8;

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed");
      setCurrent(""); setNext(""); setConfirm(""); setOpen(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid="change-password-toggle-btn"
        className="mt-4 text-xs font-bold text-brand hover:text-brand-dark flex items-center gap-1.5 transition-colors duration-200">
        <KeyRound className="w-3.5 h-3.5" /> Change Password
      </button>
    );
  }

  return (
    <form onSubmit={submit} data-testid="change-password-form" className="mt-4 pt-4 border-t border-zinc-100 space-y-2">
      <p className="text-xs font-bold text-brand-ink flex items-center gap-1.5">
        <KeyRound className="w-3.5 h-3.5 text-brand" /> Change Password
      </p>
      <Input data-testid="change-password-current-input" type="password" required autoComplete="current-password"
        placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className="rounded-sm" />
      <Input data-testid="change-password-new-input" type="password" required minLength={minLen} autoComplete="new-password"
        placeholder={`New password (min ${minLen} characters)`} value={next} onChange={(e) => setNext(e.target.value)} className="rounded-sm" />
      <Input data-testid="change-password-confirm-input" type="password" required minLength={minLen} autoComplete="new-password"
        placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-sm" />
      <div className="flex gap-2 pt-1">
        <button type="submit" disabled={saving} data-testid="change-password-submit-btn"
          className="bg-brand hover:bg-brand-dark disabled:opacity-60 text-white font-bold px-4 py-2 rounded-sm text-xs flex items-center gap-1.5 transition-colors duration-200">
          {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Save New Password
        </button>
        <button type="button" onClick={() => setOpen(false)} data-testid="change-password-cancel-btn"
          className="text-xs font-medium text-zinc-500 hover:text-zinc-700 px-2">
          Cancel
        </button>
      </div>
    </form>
  );
};
